e<template>
    <div class="register__step" data-step="complete" v-bind:class="{'active': $store.state.step == 'complete'}">
        <div>
            <h3>Congratulations</h3>
            <p>Your registration was completed successfully!</p>
            <p>You'll be redirected shortly to begin using the DVC Advantages platform.<br/>You may also click the <strong>Sign In</strong> button to go there immediately.</p>
            <footer class="register__step-footer">
                <button class="btn btn-primary btn-wide" data-direction="next" v-on:click="$store.dispatch( 'go_dashboard' );">Sign In <i class="fas fa-chevron-right" aria-hidden="true"></i></button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "DVCARegisterComplete"
}
</script>
